module.exports = __webpack_public_path__ + "static/media/difficulty_2.48347d98.svg";